import {
  LEADS_INITIAL_LOADING_SKELETON_COUNT,
  LEADS_LOADING_SKELETON_COUNT,
} from '../model/constants';

import type { LeadsRegistryTableRow } from '../model/types';

export const createLeadsRegistryLoadingSkeletonRows =
  (): LeadsRegistryTableRow[] =>
    Array.from({ length: LEADS_LOADING_SKELETON_COUNT }, (_, index) => ({
      kind: 'skeleton',
      skeletonId: `leads-registry-loading-${index}`,
    }));

export const createLeadsRegistryInitialLoadingSkeletonRows =
  (): LeadsRegistryTableRow[] =>
    Array.from(
      { length: LEADS_INITIAL_LOADING_SKELETON_COUNT },
      (_, index) => ({
        kind: 'skeleton',
        skeletonId: `leads-registry-initial-loading-${index}`,
      })
    );
